import React from 'react';
import { ReactComponent as Next } from '../../assets/custom/icons/chevron_right.svg';
import { ReactComponent as Previous } from '../../assets/custom/icons/chevron_left.svg';

export interface PaginationButtonsProps {
    page: number;
    setPage: Function;
    dataCount: number;
    rows: number;
}
const PaginationButtons = (props: PaginationButtonsProps) => {
    const { page, setPage, dataCount, rows } = props;

    const pageCount = dataCount ? Math.ceil(dataCount / rows) : 1;
    const pageNumbers: string[] = generatePageNumbers(pageCount, page + 1);

    return (
        <div className="flex-center">
            <span>{/* {translate('Page')} */}</span>
            <div
                onClick={() => {
                    if (page > 0) {
                        setPage(page - 1);
                    }
                }}
                className="button-white-w-icon-only"
            >
                <Previous />
            </div>
            {pageNumbers.map((pn, index) => {
                const _page = pn && Number(pn) ? Number(pn) : 1;
                return (
                    <div
                        key={index}
                        onClick={() => {
                            if (pn !== '...') {
                                setPage(_page - 1);
                            }
                        }}
                        className={
                            page === _page - 1 && pn !== '...'
                                ? 'button-white-w-icon-only-selected pt-4p pb-4p pr-4p pl-4p mr-2p ml-2p'
                                : 'button-white-w-icon-only pt-4p pb-4p pr-4p pl-4p mr-2p ml-2p'
                        }
                    >
                        {pn}
                    </div>
                );
            })}
            <div
                onClick={async () => {
                    if (page < pageCount - 1) {
                        setPage(page + 1);
                    }
                }}
                className="button-white-w-icon-only"
            >
                <Next />
            </div>
        </div>
    );
};

export default PaginationButtons;

const generatePageNumbers = (totalPages: number, selectedPage: number) => {
    const pageNumbers: string[] = [];

    if (totalPages <= 6) {
        for (let i = 1; i <= totalPages; i++) {
            pageNumbers.push(i !== totalPages ? `${i}` : `${i}`);
        }
    } else {
        if (selectedPage <= 5) {
            for (let i = 1; i <= 6; i++) {
                pageNumbers.push(`${i}`);
            }
            pageNumbers.push(`...`);
            pageNumbers.push(`${totalPages}`);
        } else if (selectedPage >= 5 && selectedPage < totalPages - 4) {
            pageNumbers.push(`${1}`);
            pageNumbers.push(`...`);
            pageNumbers.push(`${selectedPage - 2}`);
            pageNumbers.push(`${selectedPage - 1}`);
            pageNumbers.push(`${selectedPage}`);
            pageNumbers.push(`${selectedPage + 1}`);
            pageNumbers.push(`${selectedPage + 2}`);
            pageNumbers.push(`...`);
            pageNumbers.push(`${totalPages}`);
        } else if (selectedPage >= totalPages - 4) {
            pageNumbers.push(`${1}`);
            pageNumbers.push(`...`);
            for (let i = totalPages - 6; i <= totalPages; i++) {
                pageNumbers.push(i === totalPages ? `${i}` : `${i}`);
            }
        }
    }

    return pageNumbers;
};
